import {Link} from 'react-router-dom';
import {SoopSectionTitle} from '@soop-ui/soop-ui';
import {sendHelpClickLog} from '@/utils/help/log';
import {ROUTE} from '@/constants/main/route';
import {FAQ_MAIN_CATEGORY, HELP_LOG} from '@/constants/help';
import styles from './HelpCategory.module.scss';

const HelpCategory = () => {
  const handleCategoryClick = (category: string) => {
    sendHelpClickLog(HELP_LOG.CODE_TYPE.MAIN_CONTENTS, {
      buttonType: HELP_LOG.BUTTON_TYPE.CATEGORY,
      text: category,
    });
  };

  return (
    <div className={styles.CategoryWrapper}>
      <SoopSectionTitle>
        <SoopSectionTitle.Title size='lg'>주요 카테고리</SoopSectionTitle.Title>
      </SoopSectionTitle>
      <div className={styles.CategoryList}>
        <div className={styles.ScrollArea}>
          <ul>
            {FAQ_MAIN_CATEGORY.slice(0, 5).map(({label, key, icon}) => (
              <li key={label}>
                <Link
                  to={ROUTE.HELP.FAQ}
                  state={{mainCategory: key}}
                  onClick={() => handleCategoryClick(label)}>
                  <span className={styles[icon]}>{label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HelpCategory;
